import React from 'react';
import { Router, Location, Redirect } from '@reach/router';
import ScrollToTopBtn from './menu/ScrollToTop';
import Header from './menu/header';
import Home from './pages/home';
import Colection from './pages/colection';
import ItemDetail from './pages/ItemDetail';
import Login from './pages/login';
import Register from './pages/register';
import Profile from './pages/Profile';
import SellNFTDetails from './pages/SellNFTDetails';
import Gallery from './pages/Gallery';
import BuyNFTDetails from './pages/BuyNFTDetails';
import CreatorProfile from './pages/CreatorProfile';
import EditProfile from './pages/ProfileEdit';
import Search from './pages/Search'
import Admin from './pages/admin/Admin'
import ModerateNFT from './pages/admin/ModerateNFT'
import { createGlobalStyle } from 'styled-components';
import Collections from './pages/collection/Collections'
import AllCollections from './pages/collection/AllCollections'
import ViewCollections from './pages/collection/ViewCollection'

const GlobalStyles = createGlobalStyle`
  :root {
    scroll-behavior: unset;
  }
`;

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

const PosedRouter = ({ children }) => (
  <Location>
    {({ location }) => (
      <div id='routerhang'>
        <div key={location.key}>
          <Router location={location}>
            {children}
          </Router>
        </div>
      </div>
    )}
  </Location>
);

const app = () => (
  <div className="wraper">
    <GlobalStyles />
    <Header />
    <PosedRouter>
      <ScrollTop path="/">
        <Home exact path="/">
          <Redirect to="/home" />
        </Home>
        <Gallery path="/gallery" />
        <Colection path="/colection" />
        <ItemDetail path="/ItemDetail" />
        <CreatorProfile path="/creator-profile/:walletAddress" />
        <SellNFTDetails path="/sell-nft/:contractAddress/token-id/:tokenId" />
        <BuyNFTDetails path="/buy-nft/:contractAddress/token-id/:tokenId/item-id/:itemId" />
        <Profile path="/profile/:walletAddress" />
        <Login path="/login" />
        <Register path="/register" />
        <EditProfile path="/profile-edit/:walletAddress" />
        <Search path="search/:searchValue" />
        <Admin path="/admin/:walletAddress" />
        <ModerateNFT path="/moderate-nft/:contractAddress/token-id/:tokenId/item-id/:itemId" />
        <Collections path="/collections/:walletAddress" />
        <AllCollections path="/all-collections" />
        <ViewCollections path="/collections/:walletAddress/collection/:collectionId" />
      </ScrollTop>
    </PosedRouter>
    <ScrollToTopBtn />

  </div>
);
export default app;